export default `
<p>Effective date: May 19, 2026</p>
<p class="text paragraph">
  The present privacy policy (“<strong>Policy</strong>”) of Confindo, UAB (code of legal entity: 305534751, address: Savanorių pr. 1,
  LT-03116 Vilnius, Lithuania) (“<strong>Company</strong>” or “<strong>we</strong>”) defines the basic conditions for processing the personal data of the
  Company’s website visitors, users of our app, available in our website
  <a class="link" href="https://www.lenderspartner.com/">www.lenderspartner.com</a> and in mobile version
  Lenders Partner or contacting our Company (“<strong>you</strong>”).
</p>
<p class="text paragraph">
  Email address of the data protection officer of the Company
  <a class="link" href="mailto:dpo@confindo.com">dpo@confindo.com</a>.
</p>
<p class="text">The present Policy has been drawn up in accordance with:</p>
<ul>
  <li>General Data Protection Regulation (“<strong>GDPR</strong>”);</li>
  <li>Law on the Legal Protection of the Personal Data of the Republic of Lithuania;</li>
  <li>Law on Electronic Communications of the Republic of Lithuania; and</li>
  <li>other legislation, instructions and recommendations of supervisory authorities applicable to the Company.</li>
</ul>
<p class="text paragraph">
  If you have questions related to your personal data protection or provisions of the present Policy, please contact the
  Company by using this email address <a class="link" href="mailto:info@confindo.com">info@confindo.com</a>.
</p>
<p class="text paragraph">
  The Company adheres to the principles of lawfulness, fairness, transparency, purpose limitation, data minimisation,
  accuracy, storage limitation when processing your personal data. The Company also establishes security measures and
  procedures in its activities to protect your personal data from unlawful access, disclosure, loss, alteration,
  destruction or other unauthorized processing.
</p>
<p class="text paragraph">The terms used in the Policy shall be understood as they are defined in the GDPR.</p>
<h3>I. PURPOSES, LEGAL BASIS OF PROCESSING OF PERSONAL DATA AND THE CATEGORIES OF PROCESSED PERSONAL DATA</h3>
<p class="text paragraph">
  1.1. If you are our partner, we process your personal data for the purposes and scope indicated below:
</p>
<table>
  <thead>
    <tr>
      <th>Purposes of processing</th>
      <th>Legal basis</th>
      <th>Scope of data processing</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Our services provision to you</td>
      <td>Agreement execution</td>
      <td>
        Name, surname, e-mail address, mobile phone number, personal code, code and name of legal entity you represent.
      </td>
    </tr>
    <tr>
      <td>Provision of responses to your inquiries</td>
      <td>Your consent Agreement execution</td>
      <td>
        Name, surname, mobile phone number, email address, letters, emails, chats and other forms of communication
        messages and their content.
      </td>
    </tr>
    <tr>
      <td>
        Improvement of the quality of provided services, including the handling of your submitted complaints and/or
        claims
      </td>
      <td>Legal interest Legal obligation</td>
      <td>
        Name, surname, mobile phone number, email address, information about actions performed on the website or app,
        related technical information, IP address used during the connection of the Internet user, operating system
        version and settings of the device used to access the content/services; login information – usage time and
        duration of your session; letters, emails, chats and other forms of communication messages and their content,
        etc.
      </td>
    </tr>
  </tbody>
</table>
<p class="text paragraph">
  1.2. If you are our client, we process your personal data for the purposes and scope indicated below:
</p>
<table>
  <thead>
    <tr>
      <th>Purposes of processing</th>
      <th>Legal basis</th>
      <th>Scope of data processing</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Our services provision to you</td>
      <td>Agreement execution</td>
      <td>
        Name, surname, e-mail address, mobile phone number, personal code, if you are the representative of a legal
        entity – code and name of legal entity.
      </td>
    </tr>
    <tr>
      <td>Provision of responses to your inquiries</td>
      <td>Your consent Agreement execution</td>
      <td>
        Name, surname, mobile phone number, email address, letters, emails, chats and other forms of communication
        messages and their content.
      </td>
    </tr>
    <tr>
      <td>
        Improvement of the quality of provided services, including the handling of your submitted complaints and/or
        claims
      </td>
      <td>Legal interest Legal obligation</td>
      <td>
        Name, surname, mobile phone number, email address, information about actions performed on the website or app,
        related technical information, IP address used during the connection of the Internet user, operating system
        version and settings of the device used to access the content/services; login information – usage time and
        duration of your session; letters, emails, chats and other forms of communication messages and their content,
        etc.
      </td>
    </tr>
  </tbody>
</table>
<p class="text paragraph">
  1.3. If you are a consumer or legal entity’s representative who wants to use our partners’ (e.g., Lenders, UAB)
  services, then we can process your personal data such as name, surname, e-mail address, mobile phone number with your
  consent.
</p>
<h3>II. DIRECT MARKETING</h3>
<ol>
  <li class="text paragraph">
    2.1. We may send direct marketing communications by electronic communications services, including emails, newsletters
    and short messages:
    <ol type="a">
      <li class="text paragraph">
        (a) to legal entities without prior consent, provided that a clear, free of charge and easy-to-use option to opt out
        of the further use of electronic communications services, including emails, for direct marketing purposes is
        provided in every communication; and
      </li>
      <li class="text paragraph">
        (b) to natural persons only where:
        <ul>
          <li class="text paragraph">we have obtained the recipient's prior consent; or</li>
          <li class="text paragraph">
            the recipient is our existing client, we obtained the recipient's electronic contact details in the context
            of providing services or selling goods and the marketing relates to our own similar services or goods, while
            providing a clear, free of charge and easy-to-use opportunity to object to such use of contact details both
            at the time of collection and in every subsequent communication.
          </li>
        </ul>
      </li>
    </ol>
  </li>
  <li class="text paragraph">
    2.2. Where direct marketing communications are sent on the basis of consent, you may withdraw your consent at any
    time without affecting the lawfulness of processing based on consent before its withdrawal.
  </li>
  <li class="text paragraph">
    2.3. We provide you with a clear, free and easy-to-implement option to withdraw your consent at any time. We inform
    you that you are entitled to opt-out to receive direct marketing messages sent by us at any time by informing about
    your decision by email address <a class="link" href="mailto:info@confindo.com">info@confindo.com</a> or using the
    opt-out link in the direct marketing message itself (in short messages, newsletters).
  </li>
  <li class="text paragraph">
    2.4. All direct marketing communications sent by us will clearly identify the sender and provide a valid contact
    address through which the recipient may request to stop receiving such communications.
  </li>
  <li class="text paragraph">
    2.5. Please note that sending e-mails (including the informative messages related with our contractual obligations),
    calls, the content of which is related to the execution of concluded contracts, are not considered direct marketing
    activities.
  </li>
</ol>
<h3>III. STORAGE TERMS</h3>
<ol>
  <li class="text paragraph">
    3.1. We will store your personal data as long as it is necessary for the purposes for which it was collected and
    processed, but no longer than required by applicable laws and other legislation. At the end of this period, the
    personal data is deleted/destroyed so that it cannot be reproduced.
  </li>
  <li class="text paragraph">
    3.2. If the laws of the Republic of Lithuania or international legislation do not establish any personal data
    storage period, we determine this period, considering the legitimate purpose of data storage, the legal basis and
    the principles of personal data processing.
  </li>
  <li class="text paragraph">
    3.3. The main storage terms of personal data:

    <ol>
      <li class="text paragraph">
        3.3.1. 10 years from the date of receiving your data (in case of agreement conclusion and execution);
      </li>
      <li class="text paragraph">
        3.3.2. personal data of potential clients – 3 years from the date of receiving such data;
      </li>
      <li class="text paragraph">
        3.3.3. the storage period of your personal data processed for the purpose of direct marketing (by sending short
        messages, newsletters) is 3 (three) years from the date of receipt of the relevant data, unless you opt-out such
        processing of your personal data before the end of the specified storage period. Upon expiration of the
        mentioned term or if the person opts out-to process personal data for the purpose of direct marketing before the
        end of this term, we will stop processing your data. At the end of this period, we may ask you to renew your
        consent to direct marketing and/or personal offers;
      </li>
      <li class="text paragraph">
        3.3.4. the data of requests submitted to the company by phone/email/other electronic or physical means and the
        data of the persons who submitted the requests are stored for 2 (two) years from the date of submission of the
        request.
      </li>
    </ol>
  </li>
  <li class="text paragraph">
    3.4. Please note that in certain cases your personal data may be stored longer:
    <ol>
      <li class="text paragraph">
        3.4.1. if it is necessary to defend ourselves against requirements, claims or lawsuits and to enforce our
        rights;
      </li>
      <li class="text paragraph">
        3.4.2. if we have reasonable suspicions of illegal activity that is a subject of an investigation;
      </li>
      <li class="text paragraph">
        3.4.3. if personal data is necessary for the proper resolution of a dispute or complaint;
      </li>
      <li class="text paragraph">3.4.4. in case of other legal basis provided in legislation.</li>
    </ol>
  </li>
</ol>
<h3>IV. THE TRANSFER OF PERSONAL DATA</h3>
<ol>
  <li class="text paragraph">
    4.1. In the course of its activities, the Company may use certain data processors (service providers, for instance,
    the companies providing data storage services, software development and support companies, companies providing debt
    administration services, companies providing communication services, etc.). Some of your personal data may be
    transferred to relevant persons, but we ensure that your personal data is transferred to relevant persons only in
    such cases and only to the extent necessary for the provision of their respective services.
  </li>
  <li class="text paragraph">
    4.2. By understanding our obligation to process your personal data in strict accordance with the applicable
    requirements, we use only those service providers who have installed/committed to install appropriate technical and
    organizational security measures and we ensure that the said service providers comply with the appropriate personal
    data protection, security and confidentiality obligations established in the written agreement.
  </li>
  <li class="text paragraph">
    4.3. The following persons or institutions may also be the recipients of your personal data:

    <ol>
      <li class="text paragraph">
        4.3.1. the payment and other service providers and financial institutions whose services the Company uses in the
        course of its activities;
      </li>
      <li class="text paragraph">
        4.3.2. to Lenders, UAB, loans experts who help their customers to get consumer loans, mortgage and loans to
        legal entities at lower interest rates and better conditions. Lenders', UAB activities are registered and
        supervised by the Bank of Lithuania;
      </li>
      <li class="text paragraph">
        4.3.3. the persons administering joint data files of the debtors (for instance, UAB “Creditinfo Lietuva”, UAB
        “Scorify”, etc.);
      </li>
      <li class="text paragraph">4.3.4. the state authorities and registers;</li>
      <li class="text paragraph">4.3.5. the courts, notaries and bailiffs;</li>
      <li class="text paragraph">4.3.6. the auditors, law and finance consultants;</li>
      <li class="text paragraph">
        4.3.7. if necessary, the companies that intend to buy or would buy the Company’s business;
      </li>
      <li class="text paragraph">
        4.3.8. other third parties related to the provision of the Company’s services and/or having a legal basis to
        receive this data.
      </li>
    </ol>
  </li>
</ol>
<h3>V. THE TRANSFER OF PERSONAL DATA OUTSIDE EEA</h3>
<ol>
  <li class="text paragraph">
    5.1. It is not necessary to transfer your personal data to recipients located outside the European Economic Area
    (“<strong>EEA</strong>”) for the performance of the Company’s activities.
  </li>
  <li class="text paragraph">
    5.2. However, if in exceptional cases it is necessary to transfer some of your data to a data recipient located
    outside the EEA, we will take all necessary measures provided for by law to ensure that your personal data continues
    to be properly protected.
  </li>
  <li class="text paragraph">
    5.3. Your personal data may only be transferred outside the EEA subject to these conditions:

    <ol>
      <li class="text paragraph">
        5.3.1. the standard contractual clauses approved by the European Commission have been signed with the data
        recipient, or;
      </li>
      <li class="text paragraph">
        5.3.2. the data recipient is established in a country for which the European Commission has adopted an adequacy
        decision, i.e., the data transfer to a data recipient in such country will be treated as data transfer within
        the European Union, or;
      </li>
      <li class="text paragraph">
        5.3.3 in accordance with the Article 49 of the GDPR, you have consented to such transfer of your personal data
        outside the EEA.
      </li>
    </ol>
  </li>
</ol>
<h3>VI. HOW DO WE GET YOUR PERSONAL DATA?</h3>
<ol>
  <li class="text paragraph">
    6.1. We process your personal data that:

    <ol>
      <li class="text paragraph">6.1.1. you provide to us yourselves;</li>
      <li class="text paragraph">
        6.1.2. we receive from external sources, e.g., from law enforcement authorities, from natural persons or legal
        entities (notaries, bailiffs, lawyers, etc.), when they provide them in compliance with contractual or legal
        requirements.
      </li>
    </ol>
  </li>
  <li class="text paragraph">
    6.2. Please note that when providing personal data to us, you are responsible for the correctness, completeness and
    relevance of such data. If inaccurate, false or misleading personal data is provided, we are entitled to delete such
    data or limit access to services, etc. If you provide personal data about other persons (for instance, your
    relatives, employees, etc.), you are responsible for the correctness, completeness and relevance of such personal
    data, as well as for such person’s consent for their personal data to be provided to us. It must be noted that when
    you provide such data, we may ask you to confirm that you are entitled to provide them. If such a person asks us
    about receiving his/her personal data, we will identify you as the provider of such data.
  </li>
</ol>
<h3>VII. SECURITY OF YOUR PERSONAL DATA</h3>
<ol>
  <li class="text paragraph">
    7.1. We implement various technical and organizational security measures to ensure the security of your personal
    data and to prevent illegal or accidental destruction, alteration, disclosure, as well as any other unauthorized
    data processing and to help achieve these goals. These measures include various hardware and software, additional
    agreements with used service providers, internal rules related to personal data protection and other measures.
  </li>
  <li class="text paragraph">
    7.2. The transmission of information via electronic means of communication (e.g., email, mobile phone, etc.) may be
    less secure in individual cases for reasons beyond our control over the technical or organizational measures chosen
    by us. Therefore, to ensure the security of your confidential personal data, we recommend you not to provide us with
    information through various less secure and/or electronic systems that are not used by us.
  </li>
</ol>
<h3>VIII. THIRD PARTIES WEBSITES, THE COOKIES USED BY US</h3>
<ol>
  <li class="text paragraph">
    8.1. We may provide links to or from the websites of partners, information sources, and related parties. Please note
    that third-party websites that you access by following links on our website or app have their own privacy policies
    and we are not responsible for these privacy policies. Before submitting any personal data to another website,
    familiarize yourself with rules of the website, privacy policy and other information provided on that website.
  </li>
  <li class="text paragraph">
    8.2. We use cookies. More information on how to manage cookies, browser settings or how to delete cookies can be
    found in our <a class="link" href="/cookies-policy">Cookie policy</a>.
  </li>
</ol>
<h3>IX. YOUR AS DATA SUBJECTS RIGHTS</h3>
<ol>
  <li class="text paragraph">
    9.1. You have the following rights as data subjects:

    <ol>
      <li class="text paragraph">
        9.1.1. <strong>to access your personal data and the method of their processing</strong>. You are entitled to receive confirmation
        as to whether we are processing your personal data, as well as the right to access the processed personal data
        and other related information;
      </li>
      <li class="text paragraph">
        9.1.2. <strong>to request the correction of incorrect, inaccurate or incomplete data</strong>. If you believe that the
        information we process about you is inaccurate or incorrect, you are entitled to demand to change, clarify or
        correct this information;
      </li>
      <li class="text paragraph">
        9.1.3. <strong>to demand the deletion of your personal data (“the right to be forgotten”)</strong>. In certain circumstances
        specified in legislation (e.g., when the personal data is processed illegally, the basis for data processing has
        disappeared, etc.), you are entitled to request to delete your personal data;
      </li>
      <li class="text paragraph">
        9.1.4. <strong>to request to limit the processing of your personal data</strong>. In case of certain circumstances specified in
        the legislation (e.g., when personal data is processed illegally, etc.), you are entitled to request to limit
        the processing of your personal data;
      </li>
      <li class="text paragraph">
        9.1.5. <strong>to request the transfer of your personal data to another data controller or provide it directly in a form
        convenient for you</strong>. In certain cases, you are entitled to transfer the data that we process after receiving your
        consent and the processing of which is carried out using automated means to another data controller;
      </li>
      <li class="text paragraph">
        9.1.6. <strong>to disagree with the processing of personal data, if processed on the basis of legitimate interest</strong>,
        except in cases of legitimate reasons for such processing or the purpose is to assert, enforce or defend legal
        claims;
      </li>
      <li class="text paragraph">
        9.1.7. <strong>to withdraw the given consent to the processing of your personal data</strong>. In cases where personal data is
        processed on the basis of separate consent, you are entitled to withdraw your consent to the processing of your
        personal data at any time. In this case, we will stop processing your personal data.
      </li>
    </ol>
  </li>
  <li class="text paragraph">
    9.2. We ask you to submit the requests regarding the execution of the rights of data subjects in writing by email
    address <a class="link" href="mailto:info@confindo.com">info@confindo.com</a>.
  </li>
  <li class="text paragraph">
    9.3. If you believe that your personal data is being processed illegally or your rights related to the processing of
    personal data are being violated, please contact us in the methods specified in clause 9.2. Your requests will be
    fulfilled or rejected by indicating the reasons for the rejection within 30 (thirty) calendar days from the date of
    submission of the request. The specified term of 30 (thirty) calendar days can be extended by another 60 (sixty)
    calendar days with prior notice to you, if the request is related to a large volume of personal data. The response
    to the request will be provided in the same way as received (clause 9.2), except in cases where a more detailed
    investigation is required and the response may be provided by email. Having examined your request, we will notify
    you of the results and the steps we have taken to fulfil your request, or provide you with information of further
    steps you can take if your request has not been fulfilled or satisfied.
  </li>
  <li class="text paragraph">
    9.4. Your request to exercise your rights must meet at least the following minimum requirements:

    <ol>
      <li class="text paragraph">
        9.4.1. the request must be written, legible and understandable (the request considered as a written request must
        be submitted in any of the methods specified in clause 9.2);
      </li>
      <li class="text paragraph">
        9.4.2. the request must indicate your name, surname, other contact details (email address, phone number);
      </li>
      <li class="text paragraph">
        9.4.3. the request must contain clear and accurate information about which of the said rights and to what extent
        it is desired to exercise them;
      </li>
      <li class="text paragraph">
        9.4.4. if you wish to exercise your rights through a representative, the request must include the name and
        surname of the representative, contact details for communication and a document confirming the representation
        must be attached.
      </li>
    </ol>
  </li>
  <li class="text paragraph">
    9.5. If you contact us with a verbal request to exercise your rights as a data subject, we are entitled to ask you
    to submit a written request and we have the obligation to indicate all possible methods of submitting a written
    request and the minimum requirements applicable to the request.
  </li>
  <li class="text paragraph">
    9.6. You are also entitled to apply to the supervisory authority, if you believe that your personal data is being
    processed in violation of your rights or legitimate interests arising from relevant legislation. However, before
    contacting the supervisory authority, we encourage you to contact us immediately. Thus, we will be able to find the
    most prompt and optimal solution to the problem for both parties.
  </li>
  <li class="text paragraph">
    9.7. Please note that the said rights of data subjects may be limited to ensure the prevention, investigation,
    detection or prosecution of criminal offenses or the enforcement of criminal sanctions, including the protection
    against threats to public safety and their prevention, public safety, and in the cases of restriction of rights
    specified in the Article 23 of GDPR.
  </li>
</ol>
<h3>X. FINAL PROVISIONS</h3>
<ol>
  <li class="text paragraph">10.1. The Policy was last updated on 8 of May 2025.</li>
  <li class="text paragraph">
    10.2. The Company reserves the right to update the Policy, so it is recommended to review the present Policy
    regularly to be informed of any amendments.
  </li>
  <li class="text paragraph">
    10.3. By making amendments, we will not reduce the scope of your rights under the Policy or applicable laws of
    personal data protection.
  </li>
  <li class="text paragraph">
    10.4. The amendments to the Policy shall take effect after they are published on the website.
  </li>
</ol>

`;
